import React, { useState } from 'react';
import { Input, FormFeedback, FormGroup, Label, FormText, InputGroup, Row } from 'reactstrap';
import Add from '@mui/icons-material/Add'
import { Autocomplete, Chip, Grid, IconButton, TextField, styled } from '@mui/material';

const useStyles = styled(theme => ({
  root: {
    flexGrow: 1
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

const ChipsArray = (props) => {
  const classes = useStyles();
  const [user, setUsername] = useState("");
  var [valid, setValidUser] = useState(false);

  const handleTextChange = (event, value) => {
    setUsername(value);
  };

  const handleAddButton = event => {
    //add validation here to user on valid system users
    fetch(window.location.protocol + '//' + window.location.host + "/api/security/validateuser?username=" + user)
      .then(res => res.json())
      .then(result => {
        if (result.error) {
          //display an error to the user.
          setValidUser(true);
        }
        else {
          setValidUser(false);
          if (user != "" && user != " ") {
            props.addUser(user);
            setUsername("");
          }
        }
      }).catch(error => {
        //display the error to the user
        setValidUser(true);
      });
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <Label for="enteruser" className="s-field-title s-anchored">Add User</Label>
          <FormGroup>
            <Row style={{ marginLeft: '2px' }}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                onChange={handleTextChange}
                options={props.usernames}
                sx={{ width: 180 }}
                renderInput={(params) => <TextField {...params} value={user} label="Users" />}
              />
              {/* <Input type="text" id="enteruser" onChange={handleTextChange} value={user} invalid={valid} /> */}
              <IconButton color="primary" aria-label="add user" size="small" onClick={handleAddButton} invalid={valid} >
                <Add />
              </IconButton>
              <FormFeedback visible={valid}>User is not valid</FormFeedback>
            </Row>
          </FormGroup>
          {/*<FormFeedback visible={valid}>{errorMessage}</FormFeedback>*/}
        </Grid>
        <Grid item xs={8} style={{ maxWidth: '750px' }}>
          {props.users.map((data, i) => {
            return (
              <Chip
                key={i}
                color="primary"
                label={data}
                onDelete={() => props.handleDelete(data)}
                className={classes.chip}
              />
            );
          })}
        </Grid>
      </Grid>
    </div>
  );
}

export default ChipsArray;